import React from 'react';
import { Avatar, Group, Menu, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronUp, IconLogout } from '@tabler/icons-react';
import { useAuth0 } from '@auth0/auth0-react';

const SidebarProfileMenu = ({ compact = false, dark = false }) => {
  const { user, logout } = useAuth0();

  return (
    <Menu shadow="md" position="top-start" width={240}>
      <Menu.Target>
        {compact ? (
          <UnstyledButton
            aria-label="Profile menu"
            style={{
              width: 42,
              height: 42,
              border: dark ? '1px solid rgba(148, 163, 184, 0.25)' : '1px solid #e9ecef',
              borderRadius: 12,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: dark ? '#111827' : '#ffffff',
            }}
          >
            <Avatar src={user?.picture} radius="xl" size="sm" />
          </UnstyledButton>
        ) : (
          <UnstyledButton
            style={{
              width: '100%',
              border: dark ? '1px solid rgba(148, 163, 184, 0.25)' : '1px solid #e9ecef',
              borderRadius: 12,
              padding: '10px 12px',
              backgroundColor: dark ? '#111827' : '#ffffff',
            }}
          >
            <Group justify="space-between" wrap="nowrap">
              <Group gap="sm" wrap="nowrap">
                <Avatar src={user?.picture} radius="xl" size="sm" />
                <Stack gap={0}>
                  <Text size="sm" fw={600} c={dark ? '#E5E7EB' : undefined} lineClamp={1}>{user?.name || 'User'}</Text>
                  <Text size="xs" c={dark ? '#94A3B8' : 'dimmed'} lineClamp={1}>{user?.email || ''}</Text>
                </Stack>
              </Group>
              <IconChevronUp size={16} color={dark ? '#94A3B8' : undefined} />
            </Group>
          </UnstyledButton>
        )}
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconLogout size={16} />}
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default SidebarProfileMenu;
